import ApiMsProjectsService from '@/services/ms_projects_service'
export const state = {
  loading: false,
  projects: [],
  filteredProjects: [],
  places: [],
  specialPanels: []
}

export const getters = {
  loading: (state) => state.loading,
  projects: (state) => state.projects,
  filteredProjects: (state) => state.filteredProjects,
  places: (state) => state.places,
  specialPanels: (state) => state.specialPanels
}

export const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  SET_PROJECTS(state, payload) {
    state.projects = payload.map((item) => ({
      ...item,
      custom_code: `${item.code} - ${item.name}`
    }))
  },
  SET_FILTERED_PROJECTS(state, payload) {
    state.filteredProjects = payload
  },
  SET_PLACES(state, payload) {
    let places = []
    payload.forEach((project) => {
      places = [...places, ...project.places]
    })
    state.places = places
  },
  SET_NEW_SPECIAL_PANEL(state, payload){
    state.specialPanels.unshift(payload)
  },
  SET_SPECIAL_PANELS(state, payload) {
    state.specialPanels = payload
  },
}

export const actions = {
  async getAllProjects({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(`/all_projects`, payload)).data
      commit('SET_PROJECTS', resp)
      commit('SET_PLACES', resp)
      return resp
    } catch (error) {
      console.log(error)
      return error
    }
  },
  async getSpecialPanels({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(`/special_panel_list`, payload)).data
      commit('SET_SPECIAL_PANELS', resp.panels)
      return resp
    } catch (error) {
      console.log(error)
      return error
    }
  },
  setNewSpecialPanel({commit}, payload){
    commit('SET_NEW_SPECIAL_PANEL', payload)
  },
  async getFilteredProjects({ commit }, payload = {}) {
    commit('SET_LOADING', true)
    try {
      const resp = (await ApiMsProjectsService.get(`/filtered_projects`, payload)).data
      commit('SET_FILTERED_PROJECTS', resp)
      return resp
    } catch (error) {
      return error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  cleanFilteredProjects({ commit }) {
    commit('SET_FILTERED_PROJECTS', [])
  }
}
